import React from "react";

const Picture = ({ picture }) => {
  return <img src={picture} className="w-[500px]  bg-red-500 rounded-lg" />;
};

export default Picture;
